__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/c6a837a/packs/";